import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_SchoolTypeSetup } from "../shared/data.service";
import { SchoolTypeRequest } from "../shared/SchoolTypeRequest";

@Component({
	selector: "app-district-edit-school-type",
	templateUrl: "./district-edit-school-type.component.html",
	styleUrls: ["./district-edit-school-type.component.css"],
})
export class DistrictEditSchoolTypeComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private SchoolTypeSetupService: DataService_SchoolTypeSetup
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SelectedSchoolType = this.dialogConfig.data.SelectedSchoolType;

		this.SchoolTypeCD = this.SelectedSchoolType.SchoolTypeCD;
		this.OriginalCD = this.SelectedSchoolType.SchoolTypeCD;

		this.SchoolTypeDesc = this.SelectedSchoolType.SchoolTypeDesc;
		this.OriginalDesc = this.SelectedSchoolType.SchoolTypeDesc;

		this.DefinedBy = this.user.UserLevelID == 3 ? "School User" : "District User"; //Should only be District User
	}

	////////////////////////////////
	// Data
	////////////////////////////////

	user: any;
	SelectedSchoolType: any;

	//Form
	SchoolTypeCD: any = "";
	SchoolTypeDesc: any = "";
	DefinedBy: any = "User";

	OriginalCD: any = "";
	OriginalDesc: any = "";

	errorMessage: any = "";

	////////////////////////////////

	////////////////////////////////
	// Buttons
	////////////////////////////////
	onEdit() {
		if (this.SchoolTypeCD == "") {
			this.errorMessage = "Enter a code";
			return;
		}
		if (this.SchoolTypeDesc == "") {
			this.errorMessage = "Enter a description";
			return;
		}

		if (String(this.SchoolTypeCD) != String(this.OriginalCD)) {
			this.CheckCD();
		} else if (String(this.SchoolTypeDesc) != String(this.OriginalDesc)) {
			this.CheckDesc();
		} else {
			this.FinishUpdate();
		}
	}

	CheckCD() {
		var result = this.SchoolTypeSetupService.SchoolTypeCDUsed(this.SchoolTypeCD);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "School Type Code/Abbreviation Already in Use";
					return;
				} else {
					if (String(this.SchoolTypeDesc) != String(this.OriginalDesc)) {
						this.CheckDesc();
					} else {
						this.FinishUpdate();
					}
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		var result = this.SchoolTypeSetupService.SchoolTypeDescUsed(this.SchoolTypeDesc);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "School Type Name/Description Already in Use";
					return;
				} else {
					this.FinishUpdate();
				}
			},
			(error) => {}
		);
	}

	FinishUpdate() {
		let parms: SchoolTypeRequest = {
			SchoolTypeID: this.SelectedSchoolType.SchoolTypeID,
			SchoolTypeCD: this.SchoolTypeCD,
			SchoolTypeDesc: this.SchoolTypeDesc,
		};

		var result = this.SchoolTypeSetupService.SchoolTypeUpdateInfo(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Type was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the School Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////
}
